/**
 * ページナビ
 */
export default () => {
  const body = document.getElementsByTagName("body")[0];
  const siteNavigation = document.querySelector(".main-navigation");
  if (!siteNavigation) {
    return;
  }
  const toggleButton = siteNavigation.querySelector(".js-menuToggle");
  if ("undefined" === typeof toggleButton || toggleButton === null) {
    return;
  }

  const menu = siteNavigation.getElementsByTagName("ul")[0];
  if (!menu.classList.contains("nav-menu")) {
    menu.classList.add("nav-menu");
  }
  const menuLinks = menu.getElementsByTagName("a");
  const menuLinksWithChildren = menu.querySelectorAll(
    ".menu-item-has-children > a, .page_item_has_children > a"
  );
  for (const link of menuLinks) {
    link.addEventListener("focus", ()=>{toggleFocus()}, true);
    link.addEventListener("blur", () => toggleFocus(), true);
  }
  for (const link of menuLinksWithChildren) {
    link.addEventListener("touchstart", () => toggleFocus(), false);
  }

  /**
   * focusの切替
   */
  const toggleFocus = (event) => {
    if (event.type === "focus" || event.type === "blur") {
      let self = this;

      while (!self.classList.contains("nav-menu")) {
        if ("li" === self.tagName.toLowerCase()) {
          self.classList.toggle("focus");
        }
        self = self.parentNode;
      }

      if (event.type === "touchstart") {
        const menuItem = this.parentNode;
        event.preventDefault();
        for (const link of menuItem.parentNode.children) {
          if (menuItem !== link) {
            link.classList.remove("focus");
          }
        }
        menuItem.classList.toggle("focus");
      }
    }
  };

  /**
   * toggleボタンクリック
   */
  toggleButton.addEventListener("click", () => {
    siteNavigation.classList.toggle("toggled");
    if (toggleButton.getAttribute("aria-expanded") === "true") {
      toggleButton.setAttribute("aria-expanded", "false");
      body.dataset.navState = "close";
    } else {
      toggleButton.setAttribute("aria-expanded", "true");
      body.dataset.navState = "open";
    }
  });

  /**
   * PCサイズでスマホメニュー強制閉じる
   */
  const addMQListener = (mq, callback) => {
    if (mq.addEventListener) {
      mq.addEventListener("change", callback);
    } else {
      mq.addListener(callback);
    }
  };
  addMQListener(window.matchMedia("(min-width: 905px)"), (event) => {
    if (event.matches) {
      toggleButton.setAttribute("aria-expanded", "false");
      body.dataset.navState = "close";
    }
  });

  /**
   * SP用サブメニュー
   */
  const subMenuParents = siteNavigation.querySelectorAll(
    ".menu-item-has-children"
  );
  if (!subMenuParents || subMenuParents.length == 0) {
    return;
  }
  subMenuParents.forEach((subMenuParent) => {
    const insertBtn = document.createElement("button");
    insertBtn.classList.add("submenu-toggle", "js-subtoggle");
    insertBtn.insertAdjacentHTML("beforeend", "<span>サブメニュー開閉</span>");
    subMenuParent.appendChild(insertBtn);
    insertBtn.addEventListener("click", (event) => {
      const targetParent = event.target.parentNode;
      if (targetParent.dataset.subopen === "open") {
        targetParent.dataset.subopen = "close";
      } else {
        targetParent.dataset.subopen = "open";
      }
    });
  });
};
